import React from 'react';
import { connect } from 'react-redux';
import DocumentTitle from 'react-document-title';

import HomeScreen from 'ui/screens/HomeScreen';
import ProjectsScreen from 'ui/screens/ProjectsScreen';
import PostsScreen from 'ui/screens/PostsScreen';
import PostScreen from 'ui/screens/PostScreen';
import NotFoundScreen from 'ui/screens/NotFoundScreen';

import Header from 'ui/Header';
import Footer from 'ui/Footer';
import Toaster from 'ui/Toaster';

import { routeSelector, routeParamsSelector } from 'ducks/routeSelectors';

import {
	HOME_SCREEN,
	PROJECTS_SCREEN,
	POSTS_SCREEN,
	POST_SCREEN
} from 'routes';




class Router extends React.Component {

	render() {
		const { route, params } = this.props;

		let screen;

		switch (route) {
			case HOME_SCREEN:
				screen = <HomeScreen />;
				break;

			case PROJECTS_SCREEN:
				screen = <ProjectsScreen />;
				break;

			case POSTS_SCREEN:
				screen = <PostsScreen />;
				break;

			case POST_SCREEN:
				screen = <PostScreen slug={params.slug} />;
				break;

			default:
				screen = <NotFoundScreen />;
				break;
		}


		return (
			<DocumentTitle title="Caleb Miller">
				<div className="app-wrap">
					<Header />
					<main>
						{screen}
					</main>
					<Footer />
					<Toaster />
				</div>
			</DocumentTitle>
		);
	}
}


const mapStateToProps = state => ({
	route: routeSelector(state),
	params: routeParamsSelector(state)
});

const RouterContainer = connect(mapStateToProps)(Router);

export default RouterContainer;



// WEBPACK FOOTER //
// ./src/ui/Router.jsx